<script>
export default {
    props: {
        isRouterLink: {
            type: Boolean,
            default: false
        },
        to: {
            type: Object,
            default: null,
        }
    },

    render: function (createElement) {
        return this.isRouterLink
            ? createElement(
                'router-link',
                {
                    props: {
                        to: this.to
                    },
                },
                this.$slots.default
            )
            : createElement(
                'a',
                {
                    attrs: {
                        href: '#'
                    },
                    on: {
                        click: () => {
                            this.$emit('clicked');
                        }
                    }
                },
                this.$slots.default
            );
    }
};
</script>
